// extracted by mini-css-extract-plugin
export var carrierIcon = "_yr-0";
export var carrierLogo = "_yr-1";
export var detailsSection = "_yr-2";